import { PatientContinuouslyUsedMedicineExtended, PatientMedicine } from '@dreryk/egabinet-prescription-frontend-api';

import { TableDataAccessor, TableKeyExtractor } from '@dreryk/react-components';

import { MedicineSafetyIndicatorsConfigResolver } from '~libs.shared.medicine';

export const medicineSearchKeyExtractor: TableKeyExtractor<PatientMedicine> = (bean) => {
   return bean.medicine.id;
};

export const MedicineSearchDataAccessor: TableDataAccessor<
   PatientMedicine | PatientContinuouslyUsedMedicineExtended
> = (props) => {
   return <MedicineSafetyIndicatorsConfigResolver medicines={props.currentPage} />;
};
